import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from '@/app/App';
import { applyTheme, currentThemeId } from '@/features/theme/themes';
import '@/styles/globals.css';

// Apply the saved theme synchronously, before React's first paint, so there's
// no default-background flash before the provider hydrates.
applyTheme(currentThemeId());

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found');

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
